import { render, staticRenderFns } from "./AdminSettingsHeader.vue?vue&type=template&id=1ecb84cb&scoped=true"
import script from "./AdminSettingsHeader.vue?vue&type=script&lang=js"
export * from "./AdminSettingsHeader.vue?vue&type=script&lang=js"
import style0 from "./AdminSettingsHeader.vue?vue&type=style&index=0&id=1ecb84cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecb84cb",
  null
  
)

export default component.exports